import HttpRepository from './httpRepository'
import config from '~/config'

// 住所検索 API (Google Geocoding) が使えない状態を表すエラーコード
export const ADDRESS_API_UNAVAILABLE = 'ADDRESS_API_UNAVAILABLE'

const TIMEOUT_MS = 8000

const unavailableError = (reason) => {
  const error = new Error(`住所検索 API が利用できません (${reason})`)
  error.code = ADDRESS_API_UNAVAILABLE
  return error
}

export default class AddressRepository extends HttpRepository {
  // 戻り値: { prefecture, city } / 該当なしは undefined / API 障害・上限超過は code=ADDRESS_API_UNAVAILABLE の例外
  async send({ zipcode }) {
    const controller =
      typeof AbortController !== 'undefined' ? new AbortController() : null
    const timer = controller
      ? setTimeout(() => controller.abort(), TIMEOUT_MS)
      : null

    let json
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?language=ja&sensor=false&key=${config.googleMapApiKey}&address=${zipcode}`,
        controller ? { signal: controller.signal } : undefined
      )
      json = await response.json()
    } catch (error) {
      // ネットワーク断・タイムアウト・JSON でない応答 (5xx の HTML など)
      throw unavailableError(error?.name || 'network')
    } finally {
      if (timer) clearTimeout(timer)
    }

    // ZERO_RESULTS / INVALID_REQUEST は入力側の問題なので「該当なし」扱い。
    // それ以外 (OVER_QUERY_LIMIT, OVER_DAILY_LIMIT, REQUEST_DENIED, UNKNOWN_ERROR) は API 側の障害扱い
    const status = json?.status
    if (status && !['OK', 'ZERO_RESULTS', 'INVALID_REQUEST'].includes(status)) {
      throw unavailableError(status)
    }

    const result = json?.results?.[0]
    if (!result) {
      return undefined
    }

    const address = result.address_components
    if (!address) {
      return undefined
    }

    const prefecture = address[address.length - 2]?.long_name
    const city = address
      .slice(1, address.length - 2)
      .reverse()
      .reduce((a, b) => a + b?.long_name, '')

    return {
      prefecture,
      city
    }
  }
}
